import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { PreInitSettingsService } from '../services/settings/pre-init-setting.service';
import { format } from 'date-fns';
import { LoaderManagerService } from '../services/loader-manager.service';
import { ADPConfigService, StorageService as ADPStorageService } from 'digital-core';
import { StorageService } from '../services/storage.service';
import { isEmpty as _isEmpty } from 'lodash';

export const OKTA_TOKEN_STORAGE = 'okta-token-storage';
export const IDENTITY_TOKEN = 'IdentityToken';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
	middlewareUrl: string;
	accountPath: string;
	isProduction: string;
  subscriptionKey: string;

	constructor(private preInitSettingsService: PreInitSettingsService,
    public loaderManagerService: LoaderManagerService,
    public configService: ADPConfigService,
    public storageService: ADPStorageService,
		private pghStorageService: StorageService,
    ) {
		this.preInitSettingsService.settings.subscribe(settings =>
      this.subscriptionKey = settings?.middleWare?.subscriptionKey
    );
	}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const token: any = JSON.parse(localStorage.getItem(OKTA_TOKEN_STORAGE));
		const identityToken: any = localStorage.getItem(IDENTITY_TOKEN);
		if (!this.middlewareUrl) {
      this.middlewareUrl = this.preInitSettingsService.getSettings()?.middleWare?.middlewareUrl?.toLowerCase();
		}
		if (!this.accountPath) {
			this.accountPath = this.preInitSettingsService.getSettings()?.middleWare?.accountPath?.toLowerCase();
		}
		if (!this.isProduction) {
			this.isProduction = this.preInitSettingsService.getSettings()?.isProduction?.toLowerCase();
		}
    this.loaderManagerService.onRequestStart(request);

		let requestId = '';
		let isMiddlewareUrl = false;
		if (this.middlewareUrl && request.url.toLowerCase().startsWith(this.middlewareUrl) && !request.url.toLowerCase().endsWith('appsettings.json')) {
			let name = this.preInitSettingsService.getSiteSettings().name;
			requestId = this.getApiRequestId(name);
			isMiddlewareUrl = true;
		}

		if (token && (token.hasOwnProperty('accessToken') || token.hasOwnProperty('access_token'))) {
			let accessToken = '';
			if (token.hasOwnProperty('access_token')) {
        accessToken = token['access_token'].accessToken;
      }
			if (token.hasOwnProperty('accessToken')) {
        accessToken = token['accessToken'].accessToken;
      }
			if (requestId && isMiddlewareUrl) {
        let editor = this.storageService.getLocal<string>('content-editor-id') ?? '';
				let culture = this.pghStorageService.getLocal<string>('language');
			  culture = _isEmpty(culture) ? 'en' : culture; // Default to 'en'

				request = request.clone({
					setHeaders: {
						Authorization: 'Bearer ' + accessToken,
						'X-Api-Request-Id': requestId,
            'Content-Editor-Id': editor,
            ClientCMS: this.configService.clientCMS,
            ParentCMS: this.configService.parentCMS,
						culture: culture
					}
				});
			}
		} else if (requestId && isMiddlewareUrl) {
      let editor = this.storageService.getLocal<string>('content-editor-id') ?? '';
			let culture = this.pghStorageService.getLocal<string>('language');
			culture = _isEmpty(culture) ? 'en' : culture; // Default to 'en'

			request = request.clone({
				setHeaders: {
					'X-Api-Request-Id': requestId,
          'Content-Editor-Id': editor,
          ClientCMS: this.configService.clientCMS,
          ParentCMS: this.configService.parentCMS,
					culture: culture
				}
			});
		}

		let elitaEnv = this.pghStorageService.getLocal<string>('elita-environment') ?? this.pghStorageService.getLocal<string>('elita-environment-default');
		
		if (elitaEnv && this.isProduction == 'false' && request.url.toLowerCase().startsWith(`${this.middlewareUrl}${this.accountPath}`)) {
			request = request.clone({
        setHeaders: {
          'Elita-Environment': elitaEnv
        }
      });
		}

		if (this.subscriptionKey && isMiddlewareUrl) {
      request = request.clone({
        setHeaders: {
          'Ocp-Apim-Subscription-Key': this.subscriptionKey
        }
      });
    }

		if (identityToken  && isMiddlewareUrl) {
			request = request.clone({
				setHeaders: {
					'IdentityToken': identityToken
				}
			});
		}

		return next.handle(request).pipe(tap({
			next: (event) => {
				if (event instanceof HttpResponse && event.headers.get(IDENTITY_TOKEN)) {
					localStorage.setItem(IDENTITY_TOKEN, event.headers.get(IDENTITY_TOKEN));
				}
			},
      finalize: () => {
        this.loaderManagerService.onRequestStop(request);
      }
   	}));
	}

	private getApiRequestId(name: string) {
    let reqId = `PGH-${name}-${format(new Date(), "yyyyMMdd-HHmmssSSS")}`;
    return reqId;
  }
}
